import {soccerLeagues} from './soccerTeams'
import {olympicEvents} from './olympicTeams'
import {criketTournaments} from './cricketTeams'

export const sports = new Map();
sports.set('Soccer', soccerLeagues);
sports.set('Olympics', olympicEvents);
sports.set('Cricket', criketTournaments);
